import React from "react";
import PropTypes from "prop-types";
import Button from "../button";

const propTypes = {
  instruction: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  buttonOnClick: PropTypes.func.isRequired,
};

const EditingDisabled = ({ instruction, buttonText, buttonOnClick }) => (
  <div className="p-4 md:p-6">
    <div className="text-center heading-9 text-grey">{instruction}</div>
    <Button
      key={buttonText}
      outline={true}
      label={buttonText}
      className="mt-4 md:mt-6"
      onClick={buttonOnClick}
    />
  </div>
);

EditingDisabled.propTypes = propTypes;

export default EditingDisabled;
